import { call, put, takeLatest } from 'redux-saga/effects';
import * as T from './rootDetectionTypes';
import * as actions from './rootDetectionActions';
import { checkRootDetectionApi } from './rootDetectionApi';

function* checkRootDetectionSaga() {
  try {
    const isHighRisk: boolean = yield call(checkRootDetectionApi);
    yield put(actions.checkRootDetectionSuccess(isHighRisk));
  } catch (error: any) {
    yield put(actions.checkRootDetectionFailure(error?.message || 'Root detection failed'));
  }
}

export default function* rootDetectionSaga() {
  yield takeLatest(T.CHECK_ROOT_DETECTION_REQUEST, checkRootDetectionSaga);
}
